import { SkeletonBox } from '@circlefin/components'
import { ComplexTable } from '@shared/components/tables'
import { Body } from '@shared/components/tables/TableCard/Body/Body'
import { useTradesQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { useTradesTableColumns } from './TradesTable.Columns'

import type { Trade } from '@shared/graphql'

export interface TradesTableProps {
  /**
   * Settlement ID to filter trades by.
   */
  settlementId: string
}

export const TradesTable: React.FC<TradesTableProps> = ({ settlementId }) => {
  const { t } = useTranslation('payments')
  const columns = useTradesTableColumns()
  const { data, loading, error } = useTradesQuery({
    variables: {
      filter: { settlementId },
    },
  })

  if (loading) {
    return (
      <div className="space-y-3">
        <SkeletonBox className="h-4 w-88" loading={loading} />
        <SkeletonBox className="h-4 w-120" loading={loading} />
        <SkeletonBox className="h-4 w-48" loading={loading} />
      </div>
    )
  }

  return (
    <>
      <h2 className="mb-10 type-h-title-md">{t`tradesTable.title`}</h2>
      <Body>
        <ComplexTable<Trade>
          columns={columns}
          data={data?.trades}
          error={error}
          loading={loading}
          pagination="links"
        />
      </Body>
    </>
  )
}

TradesTable.displayName = 'TradesTable'
